import { UNZER_END_POINTS } from 'helpers/utils/endPoints';
import { useCallback } from 'react';
import { sdk } from 'sdk';
import {
  PaymentResponse,
  PaymentRequestPayload,
  KlarnaPaymentRequestPayload,
  UnzerInstallmentCreationPayload,
  SchemePaymentRequestPayload,
} from 'shared/types/cart/Payment';

const useUnzer = () => {
  const makePayment = useCallback(async (data: PaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.makePayment,
      payload: data,
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const createInvoicePayment = useCallback(async (data?: PaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.createInvoicePayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeInvoicePayment = useCallback(async (data?: PaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.makeInvoicePayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const getInstallments = useCallback(async (data?: PaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.getInstallments,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const createInstallmentPayment = useCallback(async (data: UnzerInstallmentCreationPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.createInstallmentPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeInstallmentPayment = useCallback(async (data?: PaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.makeInstallmentPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeEPSPayment = useCallback(async (data?: SchemePaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.makeEPSPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeTwintPayment = useCallback(async (data?: SchemePaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS?.makeTwintPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeGooglePayPayment = useCallback(async (data?: SchemePaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS.makeGooglePayPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makePFCardPayment = useCallback(async (data?: SchemePaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS.makePFCardPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makePFFinancePayment = useCallback(async (data?: SchemePaymentRequestPayload | KlarnaPaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS.makePFFinancePayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  const makeApplePayPayment = useCallback(async (data?: SchemePaymentRequestPayload) => {
    const response = await sdk.callAction({
      actionName: UNZER_END_POINTS.makeApplePayPayment,
      payload: data ?? {},
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  return {
    makePayment,
    createInvoicePayment,
    makeInvoicePayment,
    getInstallments,
    createInstallmentPayment,
    makeInstallmentPayment,
    makeEPSPayment,
    makeTwintPayment,
    makeGooglePayPayment,
    makePFCardPayment,
    makePFFinancePayment,
    makeApplePayPayment,
  };
};

export default useUnzer;
